var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"union-star",on:{"click":_vm.handle}},[(_vm.isActive)?_c('img',{attrs:{"src":require("../assets/images/star_on.png")}}):_c('img',{attrs:{"src":require("../assets/images/star_off.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0e022ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/star.vue
// module id = mL6P
// module chunks = 0